{
  "name": "User",
  "columns": [
    {
      "fieldName": "name",
      "displayName": "Role Name",
      "dataType": "STRING"
    },
    {
      "fieldName": "description",
      "displayName": "Description",
      "dataType": "STRING"
    },
    {
      "fieldName": "isActive",
      "displayName": "Status",
      "dataType": "BOOLEAN",
      "valueMap": {
        "true": "Active",
        "false": "Inactive"
      },
      "styleConfig": {
        "type": "status"
      }
    },
    {
      "fieldName": "createdDate",
      "displayName": "Created Date",
      "dataType": "DATETIME"
    },
    {
      "fieldName": "modifiedDate",
      "displayName": "Modified Date",
      "dataType": "DATETIME"
    },
    {
      "fieldName": "modifiedBy",
      "displayName": "Modified By",
      "dataType": "STRING",
      "styleConfig": {
        "type" : "user-avatar"
      }
    },
    {
      "fieldName": "createdBy",
      "displayName": "Created By",
      "dataType": "STRING",
      "styleConfig": {
        "type" : "user-avatar"
      }
    }
  ]
}
